import React, { useEffect, useState } from 'react';
import Table from '../../components/ui/Table/Table/Table';
import EditModal from './Modal/EditModal';
import { connect, useDispatch, useSelector } from 'react-redux';
import { customerActions } from '../../_actions';
import EditModal2 from './Modal/EditModal2';
import StatusModal from '../../components/Modals/StatusModal';
import DeleteModal from '../../components/Modals/DeleteModal';
import ViewModal from './Modal/ViewModal';
import Input from '../../components/ui/Input/Input';
import { AiOutlineFileExcel } from "react-icons/ai";
import { FiPlus } from "react-icons/fi";


function CustomerMangment() {
  const dispatch = useDispatch();
  const selector = useSelector(state => state)
  const [isCreateModal, setIsCreateModal] = useState(false)
  const [isEditModal, setIsEditModal] = useState(false)
  const currentDate = new Date();
  currentDate.setFullYear(currentDate.getFullYear() + 1);
  const oneYearLater = currentDate.toISOString().split("T")[0];

  const [isEditModalData, setIsEditModalData] = useState(null)
  const [size, setSize] = useState(100);
  const [filterData, setFilterData] = useState({ size: size });
  const generateLicenseKey = () => {
    const randomPart = () => Math.floor(1000 + Math.random() * 9000);
    return `${randomPart()}-${randomPart()}-${randomPart()}-${randomPart()}`;
  };
  const [editData, setEditData] = useState({
    date_of_birth: new Date().toISOString().split("T")[0],
    expired_on: oneYearLater,
    license_key: generateLicenseKey()
  });
  const customers = useSelector(state => state.customer.customer);
  const adminCustomer = useSelector(state => state.customer.adminCustomer);
  const [isMenu, setIsMenu] = useState(false)
  const [clickedUserId, setClickedUserId] = useState(null)
  const [isBlockModal, setIsBlockModal] = useState(false)
  const [customerBlockData, setIsCustomerBlockData] = useState(null)
  const [error, setError] = useState({});
  const [searchText, setSearchText] = useState("")
  const [selectValue, setSelectValue] = useState("")

  const [isDeleteModal, setIsDeletModal] = useState(false)
  const [deleteData, setDeleteData] = useState(null)

  const [isCustomerViewModal, setIsCoustomerViewModal] = useState(false)
  const [isCustomerViewModalData, setIsCoustomerViewModalData] = useState(null)
  const adminData = useSelector((state) => state.users.adminData);
  const adminType = adminData?.admin_type || "admin";
  const userAccess = adminData?.access?.split(",");
  const assignedCustomer = userAccess?.includes("view_customer") ? true : false;
  useEffect(() => {
    dispatch(customerActions.customerList({ ...filterData, keyWord: searchText }, assignedCustomer));
  }, [filterData, searchText, assignedCustomer]);

  const handlePageClick = (e) => {
    dispatch(customerActions.customerList({ ...filterData, page: e.selected + 1 }, assignedCustomer));
  }

  const handelFilter = (e) => {
    const { name, value } = e.target;
    setFilterData({ ...filterData, [name]: value });
  }

  const showMenu = (userId) => {
    if (clickedUserId === userId) {
      setIsMenu(!isMenu);
    } else {
      setClickedUserId(userId);
      setIsMenu(true);
    }
  };

  const theadData = [
    "Id",
    "Name",
    "Phone",
    "City",
    "Weighbridge Id",
    "License Key",
    "Referred By",
    "Expired On",
    "Login",
    "Created At",
    "Created By",
    'Status',
    "Actions"
  ];
  const stateOptions = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal"
  ];
  const handleCreate = () => {
    setIsCreateModal(!isCreateModal)
  }
  const handleOnChange = (e) => {
    let { value, name } = e.target;
    setEditData({
      ...editData, [name]: value
    })
  }
  const validate = (validKeys, data) => {
    let returnV = false;
    const tempError = { ...error };
    validKeys.forEach(name => {
      if (name === "phone") {
        if (String(data[name] || "").length != 10) {
          tempError[name] = `Phone number must have exactly 10 digits.`;
          returnV = true;
        } else {
          tempError[name] = null;
        }
      } else if (name === "state") {
        if (!data[name] || "") {
          tempError[name] = `Please select state.`;
          returnV = true;
        } else {
          tempError[name] = null;
        }
      } else {
        let message = null;
        if (name === 'f_name') {
          message = `First name required.`;
        } else if (name === 'l_name') {
          message = `Last name required.`;
        } else if (name === 'city') {
          message = `City required.`;
        } else if (name === 'weighbridge_id') {
          message = "Weigh bridge id required.";
        }
        if (!data[name]) {
          tempError[name] = `${message}`;
          returnV = true;
        } else {
          tempError[name] = null;
        }
      }
    });
    setError(tempError);
    return returnV;
  }
  const handleEditSubmit = (e) => {
    e.preventDefault();
    const validKeys = ['f_name', 'l_name', 'city', 'state', 'phone', 'weighbridge_id'];
    if (isEditModalData?.id) {

      const isValid = validate(validKeys, isEditModalData);
      if (isValid) return;
      dispatch(customerActions.updateCustomer(isEditModalData, handleCloseEditModal, assignedCustomer));
    } else {
      const isValid = validate(validKeys, editData);
      if (isValid) return;
      dispatch(customerActions.saveCustomer(editData, handleClose, assignedCustomer));
    }
  }
  const handleClose = () => {
    setIsCreateModal(!isCreateModal)
    setEditData({
      date_of_birth: new Date().toISOString().split("T")[0],
      expired_on: oneYearLater,
      license_key: generateLicenseKey()
    })
    setIsEditModalData(false);
    setError({});
  }
  const handleView = (data) => {
    setIsCoustomerViewModal(!isCustomerViewModal)
    setIsCoustomerViewModalData(data)
  }
  const toggleViewModal = () => { setIsCoustomerViewModal(!isCustomerViewModal); setIsCoustomerViewModalData(null) }
  const [sortOrder, setSortOrder] = useState("ASC");
  const sortData = () => {
    setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    dispatch(customerActions.customerList({ ...filterData, sortOrder }, assignedCustomer));
  }
  const handleEdit = (data) => {
    setIsEditModalData(() => ({
      id: data?.id || 0,
      address: data?.address || "",
      date_of_birth: data?.date_of_birth && !isNaN(new Date(data.date_of_birth).getTime())
        ? new Date(data.date_of_birth).toISOString().split('T')[0]
        : "",
      email: data?.email || "",
      city: data?.city || "",
      expired_on: data?.expired_on && !isNaN(new Date(data.expired_on).getTime())
        ? new Date(data.expired_on).toISOString().split('T')[0]
        : "",
      f_name: data?.f_name || "",
      l_name: data?.l_name || "",
      landmart: data?.landmart || "",
      license_key: data?.license_key || "",
      mac_address: data?.mac_address || "",
      phone: data?.phone || "",
      referred_by_name: data?.referred_by_name || "",
      referred_by_phone: data?.referred_by_phone || "",
      remark: data?.remark || "",
      state: data?.state || "",
      weighbridge_id: data?.weighbridge_id || "",
      gender: data?.gender || ""
    }))
    setIsEditModal(!isEditModal)
  }
  const handleCloseEditModal = () => {
    setIsEditModal(!isEditModal);
    setIsEditModalData({});
    setError({});
  }


  const handleOnChangeEdit = (e) => {
    const { value, name } = e.target;
    setIsEditModalData({
      ...isEditModalData, [name]: value
    })
  }

  const handleUserBlock = (data) => {
    setIsBlockModal(!isBlockModal)
    setIsCustomerBlockData(data)
  }
  const handleUserDelete = (data) => {
    setIsDeletModal(!isDeleteModal)
    setDeleteData(data?.id)
  }

  const handleDelete = () => {
    dispatch(customerActions.softDelete({ id: deleteData }));
    setIsDeletModal(!isDeleteModal)
  }

  const handleBlockUnblock = () => {
    dispatch(customerActions.blockUnblock(customerBlockData));
    setIsBlockModal(!isBlockModal)
    setIsCustomerBlockData(null)
  }
  const toggleBlockModal = () => {
    setIsBlockModal(!isBlockModal)
  }
  const toggleDeleteModal = () => { setIsDeletModal(!isDeleteModal) }
  const searchOption = [{ value: 'ASC', label: "Ascending" }, { value: 'DESC', label: "Descending" }]

  const handleSelect = (e) => {
    setSelectValue(e.target.value)
    dispatch(customerActions.customerList({ sortOrder: selectValue }, assignedCustomer));
  }

  useEffect(() => {
    setTimeout(() => {
      dispatch(customerActions.getAllCustomer({ ...filterData, keyWord: searchText, isAll: assignedCustomer ? "yes" : "no" }));
    }, 1500);
  }, [searchText, filterData]);

  const totalCustomer = useSelector(state => state.customer);
  const handleDownloadCSV = async () => {
    const csvHeaders = ["First Name", "Weighbridge ID", "Expired On", "Phone", "Referred By", "License Key", "Last Login"];
    if (totalCustomer?.allCustomer?.list) {
      const csvRows = totalCustomer?.allCustomer?.list.map((row) => [
        row.f_name,
        row.weighbridge_id,
        row.expired_on,
        row.phone,
        row.referred_by_name,
        row.license_key,
        new Date(row.last_login).toLocaleString(),
      ]);
      const csvContent = [
        csvHeaders.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "customers.csv";
      a.click();
      URL.revokeObjectURL(url);
    }
  }

  return (
    <>
  
      <div className="w-full p-3 bgcolor h-screen overflow-y-auto overflow-hidden">

        <div className="p-4 bg-white rounded-md  w-full space-y-4">
          <div className="flex lg:flex-row flex-col space-y-2 xl:space-y-0 gap-4">
            {userAccess && userAccess.includes("view_customer") && <div className="flex md:flex-row flex-col gap-2 w-full ">
              <Input
                className=""
                placeholder="Search..."
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
              <div className='flex md:flex-row flex-col items-center gap-2'>
                <input
                  type="date"
                  className="bg-white text-black border md:w-fit w-full rounded px-4 py-1.5 uppercase"
                  name="fromDate"
                  value={filterData?.fromDate}
                  onChange={(e) => handelFilter(e)}
                  placeholder="From Date"
                />
                <input
                  type="date"
                  className="bg-white text-black border md:w-fit w-full rounded px-4 py-1.5 uppercase"
                  name="toDate"
                  value={filterData?.toDate}
                  onChange={(e) => handelFilter(e)}
                  placeholder="To Date"
                />
              </div>
              <button
                className="border rounded-md px-4 py-2 text-black flex items-center justify-center space-x-2"
                onClick={handleDownloadCSV}
              >
                <AiOutlineFileExcel className="w-5 h-5" />
                <span className='text-sm md:text-base'>Export To Excel</span>
              </button>
            </div>}

            {/* Right Section (Add New Customer Button) */}
           {userAccess && userAccess.includes("add_customer") && <div className="md:w-fit w-full flex-shrink-0">
              <button className="px-6 py-2 bgbtn text-white rounded  flex items-center justify-center space-x-3 md:w-fit w-full " onClick={handleCreate}>
                <FiPlus className='w-5 h-5 text-black' />
                <span>Add New Customer</span>

              </button>
            </div>}
          </div>


          {/* <div className='col-span-1'>
              <button className='px-4 py-2 bgbtn text-white rounded w-full' onClick={handleCreate}>Add New Customer</button>
            </div> */}

          {/* <div className='grid xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-3 gap-3'>
            {userAccess && userAccess.includes("view_customer") &&
              <>
                <Input className="outline-none ring-0" placeholder={`Search...`} value={searchText} onChange={(e) => { setSearchText(e.target.value); console.log(e.target.value) }} />
                <input type='date' className='bg-white text-black border rounded px-4 py-1.5' name='fromDate' value={filterData?.fromDate} onChange={(e) => handelFilter(e)} placeholder='From Date' />
                <input type='date' className='bg-white text-black border rounded px-4 py-1.5' name='toDate' value={filterData?.toDate} onChange={(e) => handelFilter(e)} placeholder='To Date' />
                <button className="border rounded-md px-4 py-2  text-black flex items-center justify-between" onClick={handleDownloadCSV}>
                  <span>Export To Excel</span>
                  <span><AiOutlineFileExcel className='w-5 h-5' /></span>
                </button> 
              </>
            }
            {userAccess && userAccess.includes("add_customer") && <div>
              <button className='px-4 py-2 bgbtn text-white rounded w-full' onClick={handleCreate}>Add New Customer</button>
            </div>}
          </div> */}

          {userAccess && userAccess.includes("view_customer") &&
            <Table assignedCustomer={assignedCustomer} theadData={theadData} tbodyData={customers} handleEdit={handleEdit} handleView={handleView} isMenu={isMenu} showMenu={showMenu} clickedUserId={clickedUserId} handleUserBlock={handleUserBlock} handleUserDelete={handleUserDelete} userAccess={userAccess} searchText={searchText} handlePageClick={handlePageClick} size={size} />}
          {!assignedCustomer &&
            <Table assignedCustomer={assignedCustomer} theadData={theadData} tbodyData={customers} handleEdit={handleEdit} handleView={handleView} isMenu={isMenu} showMenu={showMenu} clickedUserId={clickedUserId} handleUserBlock={handleUserBlock} handleUserDelete={handleUserDelete} userAccess={userAccess} searchText={searchText} handlePageClick={handlePageClick} size={size} />}
        </div>
      </div>


      {isCreateModal &&
        <EditModal stateOptions={stateOptions} isOpen={isCreateModal} onClose={handleClose} editData={editData} setEditData={setEditData} handleOnChange={handleOnChange} handleEditSubmit={handleEditSubmit} error={error} />
      }
      {isEditModal &&
        <EditModal2 adminType={adminType} stateOptions={stateOptions} setIsEditModalData={setIsEditModalData} isOpen={isEditModal} onClose={handleCloseEditModal} editData={isEditModalData} handleOnChange={handleOnChangeEdit} handleEditSubmit={handleEditSubmit} error={error} />
      }

      {
        isBlockModal && (<StatusModal isOpen={isBlockModal} onSubmit={handleBlockUnblock} closeModal={toggleBlockModal} />)
      }
      {
        isDeleteModal && (<DeleteModal isOpen={isDeleteModal} onSubmit={handleDelete} closeModal={toggleDeleteModal} />)
      }
      {
        isCustomerViewModal && (<ViewModal onClose={toggleViewModal} data={isCustomerViewModalData} />)
      }
    </>
  );
};


const mapStateToProps = (state) => {
  const { user } = state
  return {
    user
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerMangment)




